import { useGetMarginRatio } from '@/app/hooks/trade/marginRatio';
import { TradeText } from './styles';
import { COLORS } from '@/app/constants/STYLES';

const TradeMarginRatio = ({ item }: any) => {
  const marginRatio = useGetMarginRatio(item);

  // NaN이나 유효하지 않은 값 처리
  const safeMarginRatio =
    isNaN(marginRatio) || !isFinite(marginRatio) ? 0 : marginRatio;

  return (
    <TradeText
      style={{
        letterSpacing: 0,
        minWidth: 90,
        whiteSpace: 'nowrap',
        height: 17,
        alignItems: 'flex-end',
        fontFamily: 'NanumSquareRound',
        fontSize: 12,
        color:
          safeMarginRatio > 80
            ? COLORS.lightRed
            : safeMarginRatio > 50
              ? '#007AFF'
              : 'inherit',
      }}
    >
      {safeMarginRatio.toFixed(2)}%
    </TradeText>
  );
};

export default TradeMarginRatio;
